import React from 'react';
import {
    Grid, Box, Link, Button,
    Card, Typography, CardContent, CardActions, CardHeader, CardMedia,
    Avatar, IconButton, 
} from '@mui/material';

const AppLink = props => {
    return (
        <Box m={2} >
            <Grid container spacing={3}>
                <Grid item xs={4}>
                    준비중입니다
                </Grid>
            </Grid>
        </Box>
    )
};

export default AppLink;